import { useDispatch } from 'react-redux';
import {show} from "@store/confirm-reducer";

export const useConfirm = () => {
	const dispatch = useDispatch()

	return ({
			title = 'Требуется подтверждение',
			text = null,
		  loading = false,
			onConfirm = new Function(),
			onCancel = new Function(),
			...rest
	}) => dispatch(show({title, text, loading, onConfirm, onCancel, ...rest}));
}
